import { PaymentInstructionMobile } from './PaymentInstructionMobile'

export const PaymentInstruction = (props: any) => {
  return (
    <>
      <PaymentInstructionMobile {...props} />
    </>
  )
}
